const SMS_TYPE = Object.freeze({
  offUnspecified: 'off_unspecified',
  offRequested: 'off_requested',
  onUnspecified: 'on_unspecified',
  onRequested: 'on_requested',
});

// noinspection JSUnusedGlobalSymbols
export default SMS_TYPE;
